import { render, staticRenderFns } from "./CurrentCorrection.vue?vue&type=template&id=5e567bcc&scoped=true&"
import script from "./CurrentCorrection.vue?vue&type=script&lang=js&"
export * from "./CurrentCorrection.vue?vue&type=script&lang=js&"
import style0 from "./CurrentCorrection.vue?vue&type=style&index=0&id=5e567bcc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e567bcc",
  null
  
)

export default component.exports